<template>
  <div>
    <v-data-table
      v-model="selected"
      item-key="id"
      show-select
      :headers="headers"
      :items="displayList"
      :search="search" class="elevation-1" 
      :loading="loading"
      :sort-by="sortBy"
      :page.sync="page"
      @page-count="pageCount = $event"
      loading-text="Loading... Please wait"
    >
    <template v-slot:top>

      <v-toolbar flat>
        <v-toolbar-title>Blood Test</v-toolbar-title>
        <v-divider class="mx-4" inset vertical /> 
        <v-spacer />
        <v-select
          v-model="selectedLocation"
          :items="locations"
          label="Location"
          outlined
        ></v-select>
        <v-spacer />

        <div class="pr-4 pb-2">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="warning" class="" @click="dialogAutoAppointment = true" :disabled="selected.length==0" v-bind="attrs" v-on="on">
                Auto Appointment ({{selected.length}})
              </v-btn>
            </template>
            <span>ตรวจสอบตารางนัดทั้งหมด ลบนัดคนที่ยังไม่ได้ฉีดเข็ม 2 และสร้างนัดให้คนที่ฉีดเข็ม 2 แล้ว</span>
          </v-tooltip>
        </div>

        <div class="pr-4">
          <v-btn color="success" class="mb-2" @click="newPatient">New Subject</v-btn>
        </div>

        <div>
          <v-btn color="primary" class="mb-2" @click="exportData"><v-icon>mdi-export</v-icon> Export</v-btn>
        </div>

        <!-- Edit / New -->
        <v-dialog v-model="dialog" max-width="1100px">
          <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" class="mb-2" v-bind="attrs" v-on="on" >New Blood Test</v-btn>
          </template> -->
          <v-card>

            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text class="pb-0">
              <v-container class="pb-0">
                <v-form v-bind:disabled="loading" lazy-validation ref="dialogForm">
                  <v-row>
                  <v-col cols="12">
                    ข้อมูลส่วนตัว
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field
                      v-model="editedItem.profile.fName"
                      label="First Name"
                      outlined
                      :rules="!editedItem.isNewPatient ? [] : [rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field
                      v-model="editedItem.profile.lName"
                      label="Last Name"
                      outlined
                      :rules="!editedItem.isNewPatient ? [] : [rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field
                      v-model="editedItem.profile.idCard"
                      label="Citizen ID / Passport"
                      outlined
                      :rules="!editedItem.isNewPatient ? [] : [rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field
                      v-model="editedItem.profile.tel" 
                      label="Phone"
                      outlined
                      :rules="!editedItem.isNewPatient ? [] : [rules.required]"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="8" md="2">
                    <v-menu
                      v-model="dateDobShow"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedItem.profile.birthDate"
                          label="วัน เดือน ปี เกิด"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          hide-details
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editedItem.profile.birthDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="4" md="2">
                    <v-text-field
                      :value="age(editedItem.profile)"
                      label="Age"
                      outlined
                      readonly
                      filled
                      hide-details
                      class="mt-0"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="2" v-if="editedItem">
                    <v-select
                      v-model="editedItem.profile.bloodType"
                      :items="bloodGroups"
                      item-text="value"
                      item-value="key"
                      label="Blood Group"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="2" v-if="editedItem">
                    <v-select
                      v-model="editedItem.profile.gender"
                      :items="genders"
                      item-text="value"
                      item-value="key"
                      label="Gender"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" v-if="editedItem">
                    <v-select
                      v-if="employeeTypeArray"
                      v-model="editedItem.profile.pQ1"
                      :items="employeeTypeArray"
                      item-text="value"
                      item-value="key"
                      label="SCG Employee"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>

                  <!----------------------------------------------------->
                  <template v-if="editedItem && editedItem.vaccine">
                    <v-col cols="12" class="py-0">
                      <v-divider />
                    </v-col>
                    
                    <v-col cols="12">
                      ประวัติการฉีดวัคซีน
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        v-model="editedItem.vaccine.vQ2"
                        :items="[{key: 'N', value: 'ไม่เคย'}, {key: 'Y', value: 'เคย'}]"
                        label="เคยรับการฉีดวัคซีนโควิด-19"
                        item-text="value"
                        item-value="key"
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="editedItem.vaccine.vQ4"
                        :items="['1', '2', '3']"
                        label="จำนวนเข็มที่ได้รับ"
                        outlined
                        hide-details
                        :readonly="editedItem.vaccine.vQ2 !== 'Y'"
                        :filled="editedItem.vaccine.vQ2 !== 'Y'"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-menu
                        v-model="dateVaccine1Show"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        :disabled="editedItem.vaccine.vQ2 !== 'Y'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.vaccineDate1"
                            label="วันที่ได้รับเข็มที่ 1"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            hide-details
                            :filled="editedItem.vaccine.vQ2 !== 'Y'"
                            class="mt-0"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedItem.vaccineDate1"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-select
                        v-model="editedItem.vaccine.vQ3"
                        :items="vaccines"
                        label="ชนิดวัคซีนเข็มที่ 1 ที่ได้รับ"
                        :readonly="editedItem.vaccine.vQ2 !== 'Y'"
                        :filled="editedItem.vaccine.vQ2 !== 'Y'"
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-menu
                        v-model="dateVaccine2Show"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        :disabled="editedItem.vaccine.vQ2 !== 'Y' || (editedItem.vaccine.vQ4 !== '2'&& editedItem.vaccine.vQ4 !== '3')"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.vaccineDate2"
                            label="วันที่ได้รับเข็มที่ 2"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            hide-details
                            :filled="editedItem.vaccine.vQ2 !== 'Y' || (editedItem.vaccine.vQ4 !== '2'&& editedItem.vaccine.vQ4 !== '3')"
                            class="mt-0"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedItem.vaccineDate2"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="editedItem.vaccine.vQ7"
                        :items="vaccines"
                        label="ชนิดวัคซีนเข็มที่ 2 ที่ได้รับ"
                        :readonly="editedItem.vaccine.vQ2 !== 'Y'|| (editedItem.vaccine.vQ4 !== '2'&& editedItem.vaccine.vQ4 !== '3')"
                        :filled="editedItem.vaccine.vQ2 !== 'Y'|| (editedItem.vaccine.vQ4 !== '2'&& editedItem.vaccine.vQ4 !== '3')"
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-menu
                        v-model="dateVaccine3Show"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        :disabled="editedItem.vaccine.vQ2 !== 'Y' || editedItem.vaccine.vQ4 !== '3'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.vaccineDate3"
                            label="วันที่ได้รับเข็มที่ 3"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            hide-details
                            :filled="editedItem.vaccine.vQ2 !== 'Y' || editedItem.vaccine.vQ4 !== '3'"
                            class="mt-0"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedItem.vaccineDate3"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-select
                        v-model="editedItem.vaccine.vQ10"
                        :items="vaccines"
                        label="ชนิดวัคซีนเข็มที่ 3 ที่ได้รับ"
                        :readonly="editedItem.vaccine.vQ2 !== 'Y'|| editedItem.vaccine.vQ4 !== '3'"
                        :filled="editedItem.vaccine.vQ2 !== 'Y'|| editedItem.vaccine.vQ4 !== '3'"
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>

                  <v-col cols="12" sm="6" md="3" v-if="editedItem">
                    <v-select
                      v-model="editedItem.vaccine.vQ12"
                      :items="yn"
                      item-text="value"
                      item-value="key"
                      label="ท่านอยู่ระหว่างได้รับยากดภูมิคุ้มกันหรือไม่"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" v-if="editedItem">
                    <v-text-field
                      v-model="editedItem.vaccine.vQ13"
                      label="ระบุชื่อยา"
                      outlined
                      :disabled="!editedItem.vaccine.vQ12 || editedItem.vaccine.vQ12!='Y'"
                      :rules="!editedItem.vaccine.vQ12 || editedItem.vaccine.vQ12!='Y' ? [] : [rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" v-if="editedItem">
                    <v-select
                      v-model="editedItem.vaccine.vQ14"
                      :items="yn"
                      item-text="value"
                      item-value="key"
                      label="ท่านมีโรคประจำตัวหรือไม่"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" v-if="editedItem">
                    <v-text-field
                      v-model="editedItem.vaccine.vQ15"
                      label="ระบุโรคประจำตัว"
                      outlined
                      :disabled="!editedItem.vaccine.vQ14 || editedItem.vaccine.vQ14!='Y'"
                      :rules="!editedItem.vaccine.vQ14 || editedItem.vaccine.vQ14!='Y' ? [] : [rules.required]"
                    ></v-text-field>
                  </v-col>
                    <v-col cols="12" v-if="editedItem" v-html="latestVaccineInfo()"></v-col>
                  </template>
                  <template v-if="editProfileOnly === false">
                    <!----------------------------------------------------->
                    <v-col cols="12" class="py-0">
                      <v-divider />
                    </v-col>
                    
                    <v-col cols="12">
                      ข้อมูลการวันนัด
                    </v-col>
                    <v-col cols="6" md="2">
                      <v-text-field
                        v-model="editedItem.bloodTest.round"
                        type="number"
                        label="Round"
                        outlined
                        class="mt-0"
                        @input="onRoundChange"
                        :rules="[rules.required, rules.number]"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        v-model="editedItem.bloodTest.status"
                        :items="statuses"
                        label="Status"
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-text-field :disabled="loading" v-model="editedItem.bloodTest.location" label="Location" outlined></v-text-field>
                    </v-col>
                    <!-- -->
                    <v-col cols="12" md="2">
                      <v-menu
                        v-model="dateShow"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.bloodTest.date"
                            label="วันเจาะเลือด"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedItem.bloodTest.date"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-menu
                        v-model="timeShow"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.bloodTest.time"
                            label="Time"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-model="editedItem.bloodTest.time"
                          format="24hr"
                          scrollable
                          min="8:00"
                          max="18:00"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="8">
                      
                    <v-checkbox
                      id="appointment_approved"
                      name="appointment_approved"
                      type="checkbox"
                      value="Y"
                      label="มาตามนัด"
                      class="input-checkbox mt-3"
                      v-model="editedItem.bloodTest.appointment_approved"
                    />
                    
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-divider />
                    </v-col>

                    <!----------------------------------------------------->
                    <v-col cols="12">
                      ข้อมูลผลการตรวจ
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-text-field :disabled="loading" v-model="editedItem.bloodTest.si" label="Sample ID" outlined hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field :disabled="loading" v-model="editedItem.bloodTest.RUmL" label="Quantitative (RU/mL)" outlined hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field :disabled="loading" v-model="editedItem.bloodTest.ratio" label="Ratio" outlined hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="editedItem.bloodTest.result"
                        label="Result"
                        :items="results"
                        item-text="title"
                        item-value="value"
                        outlined
                        hide-details=""
                        @change="interpretation = interpretationOfBloodTest(editedItem.bloodTest)"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field :disabled="loading" v-model="editedItem.bloodTest.vnt" label="Virus Neutralization Test" outlined hide-details></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="6">
                      <v-textarea :readonly="true" v-model="interpretation" label="Interpretation" outlined filled hide-details></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea :disabled="loading" v-model="editedItem.bloodTest.detail" label="Note" outlined hide-details></v-textarea>
                    </v-col>
                  </template>
                </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="loading" color="red darken-1" text @click="deleteRound">Delete</v-btn>
              <v-btn :disabled="loading" color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn :disabled="loading || canSaveProfile() !== true" color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAutoAppointment" max-width="860px">
          <v-card>
            <v-card-title>
              <span class="headline">โปรดระวัง</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                ระบบจะตรวจสอบตารางนัดหมายทั้งหมด <strong>และ</strong><br/>
                <ul>
                  <li>ลบตารางนัดหมายรอบที่ 3, 4, 5, 6 ของอาสาสมัครที่ <strong>ยังไม่ได้ฉีดเข็ม 2</strong> และ <strong>ไม่ได้มีสถานะเป็น "รายงานผลเรียบร้อย"</strong></li>
                  <li>สร้างตารางนัดรอบที่ 3, 4, 5, 6 ของอาสาสมัครที่ <strong>ฉีดเข็ม 2 แล้วแต่ยังไม่มีตารางนัด</strong> ให้อัตโนมัติ <strong>โดยอ้างอิงจากวันที่ฉีดเข็ม 2</strong></li>
                </ul>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogAutoAppointment = false">Cancel</v-btn>
              <v-btn color="red darken-1" text @click="checkAppointment">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-btn text icon class="mb-2 ml-2" @click="initialize">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        
      </v-toolbar>
    </template>

    <template v-slot:[`body.prepend`]="{ headers }">
        <tr class="mx-0 px-0">
          <td :colspan="headers.length" class="mx-0 px-0">
            <v-text-field  v-model="search" prepend-inner-icon="mdi-magnify" label="Search" single-line hide-details filled class="px-0 mx-0"/>
          </td>
        </tr>
    </template>

    <template v-slot:[`item.name`]="{ item }" >
      <a href="#" @click="editProfile(item)"><small>{{ item.name }}</small></a>
    </template>

    <template v-slot:[`item.is_scg`]="{ item }" >
      <small>{{ item.is_scg }}</small>
    </template>

    <template v-slot:[`item.id`]="{ item }" >
      <small>{{ item.id }}</small>
    </template>

    <template v-slot:[`item.mobile`]="{ item }" >
      <small>{{ item.mobile }}</small>
    </template>

    <template v-slot:[`item.total_vaccine`]="{ item }" >
      <small>{{ item.vaccine.vQ2 === 'Y' ? item.total_vaccine : '-' }}</small>
    </template>

    <template v-slot:[`item.vaccine_date1`]="{ item }" >
      <small>{{ item.vaccine_date1 | isoToShortDate }}</small>
    </template>

    <template v-slot:[`item.vaccine_type`]="{ item }" >
      <small>{{ item.vaccine.vQ2 === 'Y' ? item.vaccine_type : '-' }}</small>
    </template>

    <template v-slot:[`item.vaccine_date2`]="{ item }" >
      <small>{{ item.vaccine_date2 | isoToShortDate }}</small>
    </template>

    <template v-slot:[`item.vaccine_type2`]="{ item }" >
      <small>{{ item.vaccine.vQ2 === 'Y' ? item.vaccine_type2 : '-' }}</small>
    </template>
    
    <template v-slot:[`item.vaccine_date3`]="{ item }" >
      <small>{{ item.vaccine_date3 | isoToShortDate }}</small>
    </template>

    <template v-slot:[`item.vaccine_type3`]="{ item }" >
      <small>{{ item.vaccine.vQ2 === 'Y' ? item.vaccine_type3 : '-' }}</small>
    </template>

    <template v-slot:[`item.status`]="{ item }" >
      <template v-if="item.status === 'approve'">
        <v-icon color="success" small>mdi-shield-check-outline</v-icon>
      </template>
      <template v-else>
        <v-icon color="error" small>mdi-shield-off-outline</v-icon>
      </template>
    </template>

    <template v-for="round in numberOfRound" v-slot:[`item.round_${round}`]="{ item }">
      <div v-bind:key="`${item.lineId}_round_${round}`">
        <div
          v-for="(bloodTest, bloodTestIndex) in [bloodTestOfRound(item, round)]"
          v-bind:key="`${item.lineId}_round_${round}_${bloodTestIndex}`"
        >
          <template v-if="bloodTest === roundStatusSkip">
            <small class="red--text">ข้าม</small>
          </template>
          
          <template v-else-if="bloodTest === roundStatusCreatableRepeat">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="warning" class="" small @click="checkAppointmentSingleItem(item)" v-bind="attrs" v-on="on">
                  <v-icon small>mdi-expand-all-outline</v-icon>
                </v-btn>
              </template>
              <span>สร้างตารางนัดทั้งหมดโดยคำนวนจากการฉีดเข็ม {{ item.vaccineDate3 ? '3' : '2' }}</span>
            </v-tooltip>
          </template>

          <template v-else-if="bloodTest === roundStatusCreatable">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" class="" small @click="newItem(item, round)" v-bind="attrs" v-on="on">
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>สร้างตารางนัดวันที่ต้องการ</span>
            </v-tooltip>
          </template>

          <template v-else-if="bloodTest === roundStatusCannotCreate">
            <v-btn color="primary" class="" small disabled>
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
          </template>

          <template v-else-if="bloodTest === roundStatusUnknown">
            -
          </template>

          <template v-else-if="bloodTest === roundStatusNotReachable">
            <div class="red--text">&times;</div>
          </template>

          <template v-else>
            <a href="#" @click="editItem(item, round)">
              <small :class="{ 'warning--text': bloodTest.status === statuses[0], 'success--text': bloodTest.status === statuses[1] }">
                {{ bloodTest.date | shortDate }}
                <!-- <br>{{ bloodTest.status | blankOrDash }} -->
              </small>
            </a>
          </template>
        </div>
      </div>
    </template>

    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  <div class="text-center pt-2">
    <v-pagination
      v-model="page"
      :length="pageCount"
      :total-visible="20"
    ></v-pagination>
  </div>

  <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false">Close</v-btn>
      </template>
  </v-snackbar>

  <v-snackbar v-model="snackLoading" :timeout="-1" color="success">
      Loading...
  </v-snackbar>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
const moment = require('moment');

export default {
  data() {
    return {
      selected:[],
      recordList: [],
      sortBy: ['rCode'],
      displayList: [],
      snack: false,
      snackColor: '',
      snackText: '',
      snackLoading: false,
      search: '',
      loading: true,

      page: 1,
      pageCount: 0,

      dialog: false,
      dateDobShow: false,
      dateShow: false,
      timeShow: false,

      dialogAutoAppointment: false,

      dateVaccine1Show: false,
      dateVaccine2Show: false,
      dateVaccine3Show: false,

      locations: [],
      selectedLocation: 'All',

      rules: {
        required: value => !!value || 'Required.',
        number: value => {
          const pattern = /^[\d]+$/
          return (pattern.test(value) && parseInt(value) >= 1 && parseInt(value) <= this.numberOfRound) || `Only number in range 1 - ${this.numberOfRound}`
        }
      },

      roundStatusSkip: -1,
      roundStatusCreatable: 1,
      roundStatusCreatableRepeat: 2,
      roundStatusCannotCreate: 3,
      roundStatusUnknown: 4,
      roundStatusNotReachable: 5,

      statuses: [
        'วันนัดเจาะเลือด',
        'รายงานผลเรียบร้อย'
      ],
      results: [
        {
          title: 'Positive',
          value: 1
        },
        {
          title: 'Negative',
          value: -1
        }
      ],
      resultInterpretations: [
        {
          positive: {
            title: 'ร่างกายเคยติดเชื้อไวรัสมาแล้วหรือกำลังติดเชื้อไวรัส SARS-CoV-2 (ในช่วง 10-14 วัน)',
            description: 'กรณีพบผลบวก แสดงว่าร่างกายของท่านมีการสร้างแอนติบอดีต่อโรคโควิด-19 อย่างไรก็ตาม ควรมีการปฏิบัติตนตามมาตรการป้องกันโรคโควิด-19 ของคณะกรรมการบริหารสถานการณ์การแพร่ระบาดของโรคติดเชื้อไวรัสโคโรนา 2019 (ศบค.)',
          },
          negative: {
            title: 'ร่างกายยังไม่มีการสร้างแอนติบอดีต่อเชื้อไวรัส SARS-CoV-2',
            description: '',
          },
        },
        {
          positive: {
            title: 'ร่างกายตอบสนองโดยการสร้างแอนติบอดีต่อวัคซีนเข็มที่ 1',
            description: '',
          },
          negative: {
            title: 'ร่างกายยังไม่สร้างแอนติบอดีต่อวัคซีนเข็มที่ 1',
            description: '',
          },
        },
        {
          positive: {
            title: 'ร่างกายตอบสนองโดยการสร้างแอนติบอดีต่อวัคซีนเข็มที่ 1 และ 2',
            title3: 'ร่างกายตอบสนองโดยการสร้างแอนติบอดีต่อวัคซีนเข็มที่ 1, 2 และ 3',
            description: '',
            description3: '',
          },
          negative: {
            title: 'ร่างกายยังไม่สร้างแอนติบอดีต่อวัคซีนเข็มที่ 1 และ 2',
            title3: 'ร่างกายยังไม่สร้างแอนติบอดีต่อวัคซีนเข็มที่ 1, 2 และ 3',
            description: '',
            description3: '',
          },
        },
      ],
      vaccines: ['Astrazeneca', 'Johnson & Johnson', 'Moderna', 'Pfizer', 'Sinopharm', 'Sinovac'],
      daysAfterVaccinated2: [0, 0, 28, 84, 168, 336],
      numberOfRound: 10,
      additionalDays: 14, // 2 weeks
      interpretation: '',
      editProfileOnly: false,
      editedItem: {
        uid: '',
        bloodTest: {
          date: (new Date).toISOString().substr(0, 10),
          time: (new Date).toISOString().substr(11, 8),
          location: '',
          status: '',
          round: 0,
          RUmL: '',
          appointment_approved:null,
          result: '',
          brief: '',
          detail: '',
          ratio: '',
          vnt: '',
          si: '', // sample id
          isNew: false,
        },
        bloodTests: ['All'],
        profile: {
          fName: '',
          lName: '',
          age: '',
          birthDate: '',
          bloodType: '',
          gender: '',
          idCard: '',
          tel: ''
        },
        history: {},
        symptom: {},
        vaccine: {
          vQ1: '',
          vQ1a: '',
          vQ2: '',
          vQ2a: '',
          vQ3: '',
          vQ4: '',
          vQ5: '',
          vQ6: '',
          vQ7: '',
          vQ10: '',
          vQ11: '',
          vQ12: '',
          vQ13: '',
          vQ14: '',
          vQ15: '',
        },
        vaccineDate1: '',
        vaccineDate2: '',
        vaccineDate3: '',
      },
      defaultItem: {
        uid: '',
        bloodTest: {
          date: (new Date).toISOString().substr(0, 10),
          time: (new Date).toISOString().substr(11, 8),
          location: '',
          status: '',
          round: 0,
          RUmL: '',
          appointment_approved:null,
          result: 0,
          brief: '',
          detail: '',
          ratio: '',
          vnt: '',
          si: '', // sample id
          isNew: false,
        },
        bloodTests: [],
        profile: {
          fName: '',
          lName: '',
          age: '',
          birthDate: '',
          bloodType: '',
          gender: '',
          idCard: '',
          tel: ''
        },
        history: {},
        symptom: {},
        vaccine: {
          vQ1: '',
          vQ1a: '',
          vQ2: '',
          vQ2a: '',
          vQ3: '',
          vQ4: '',
          vQ5: '',
          vQ6: '',
          vQ7: '',
          vQ10: '',
          vQ11: '',
          vQ12: '',
          vQ13: '',
          vQ14: '',
          vQ15: '',
        },
        vaccineDate1: '',
        vaccineDate2: '',
        vaccineDate3: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      employeeTypes: 'constant/employeeTypes',
      questions:  'constant/questions',
      bloodGroups: 'constant/bloodGroups',
      genders: 'constant/genders',
      yn:'constant/yn',
    }),
    employeeTypeArray() {
      return Object.keys(this.employeeTypes).map(key => {
        return {
          key: key,
          value: this.employeeTypes[key]
        }
      });
    },
    employeeTypeArrayForExport() {
      return [
        {
          key: 'all',
          value: 'All'
        },
        {
          key: 'scg_only',
          value: 'พนักงาน SCG เท่านั้น'
        },
        {
          key: 'scg_and_other',
          value: 'พนักงาน SCG และในเครือ'
        },
        ...this.employeeTypeArray
      ];
    },
    daysAfterPrevious() {
      var tmp = [0, 0];
      for (var i = 2; i <= this.daysAfterVaccinated2.length - 1; i++) {
        tmp.push(this.daysAfterVaccinated2[i] - this.daysAfterVaccinated2[i - 1]);
      }
      return tmp;
    },
    formTitle() {
      return this.editProfileOnly ? 'Edit Profile' : (this.editedItem.bloodTest.isNew ? "New Blood Test" : "Edit Blood Test");
    },
    headers() {
      var tmp = [
        {
          text: "Code",
          align: "center",
          sortable: true,
          value: "rCode"
        },
        {
          text: "Approve",
          align: "center",
          sortable: true,
          value: "status"
        },
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "name"
        },
        {
          text: "SCG Employee",
          align: "center",
          sortable: true,
          value: "is_scg"
        },
        // {
        //   text: "Gender",
        //   align: "center",
        //   sortable: true,
        //   value: "gender"
        // },
        {
          text: "Citizen ID / Passport",
          align: "center",
          sortable: true,
          value: "id"
        },
        {
          text: "Mobile",
          align: "center",
          sortable: true,
          value: "mobile"
        },

        {
          text: "Vaccinated",
          align: "center",
          sortable: true,
          value: "total_vaccine"
        },
        {
          text: "Vaccine #1",
          align: "center",
          sortable: true,
          value: "vaccine_date1"
        },
        {
          text: "Vaccine",
          align: "center",
          sortable: true,
          value: "vaccine_type"
        },
        {
          text: "Vaccine #2",
          align: "center",
          sortable: true,
          value: "vaccine_date2"
        },
        {
          text: "Vaccine #2 type",
          align: "center",
          sortable: true,
          value: "vaccine_type2"
        },
        {
          text: "Vaccine #3",
          align: "center",
          sortable: true,
          value: "vaccine_date3"
        },
        {
          text: "Vaccine #3 type",
          align: "center",
          sortable: true,
          value: "vaccine_type3"
        },
      ];

      for (var round = 1; round <= this.numberOfRound; round++) {
        tmp = tmp.concat([{
          text: `Round ${round}`,
          align: "center",
          sortable: false,
          value: `round_${round}`
        }]);
      }

      return tmp;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    selectedLocation() {
      this.refresh();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
        this.loading = true;
        try {
          await this.loadBloodTest()
        } catch (e) {
          console.error(e);
        }
        this.loading = false;
    },
    async loadBloodTest() {
      this.showLoadingSnack();

      const dbRef = this.$firebase.database().ref('immunity/blood')
      this.recordList = []
      this.locations = ['All'];
      var tmpLocations = {};
      dbRef.once('value').then(async (snapshot) => {
        snapshot.forEach((snap) => {
          const idCard = snap.key;
          const val = Object.assign({}, snap.val());
          const profile = val['profile'] ?? null;
          const bloodTests = Object.keys(val).filter(e => e.includes('blood')).map(e => val[e]);

          bloodTests.sort((a, b) => a.round - b.round);

          bloodTests.forEach(b => {
            if (b.location) {
              tmpLocations[b.location] = true;
            }

            b.previousRound = b.round;
          })

          this.recordList.push({
            id: idCard,
            name: this.$options.filters.profileName(profile),
            gender: profile ? profile.gender ?? '-' : '-',
            mobile: profile ? profile.tel ?? '-' : '-',
            status: profile ? profile.status ?? '' : '',
            rCode: profile ? profile.rCode ?? '-' : '-',
            lineId: val['uid'] ?? '',
            vaccine: val['vaccine'] ?? null,
            bloodTests: bloodTests,
            profile,
            is_scg: this.employeeType(val.profile),

            // will be fill with vaccine history
            total_vaccine: 0,
            vaccine_date1: '-',
            vaccine_type: '-',
            vaccine_date2: '-',
            vaccine_type2: '-',
            vaccine_date3: '-',
            vaccine_type3: '-',
          })
        })

        this.locations = this.locations.concat(Object.keys(tmpLocations).sort((a, b) => a.localeCompare(b)));
        await this.loadUserData();
        this.refresh();
        this.hideLoadingSnack();
      })
    },
    async loadUserData() {
      return new Promise((resolve) => {
        const dbRef = this.$firebase.database().ref('immunity/user')
        dbRef.once('value').then((snapshot) => {
          var snaps = {};
          snapshot.forEach((snap) => {
            snaps[snap.key] = snap.val();
          });

          this.recordList.forEach((found) => {
            var val = snaps[found.lineId];

            var vaccineDate1 = '';
            var vaccineDate2 = '';
            var vaccineDate3 = '';

            if (val && val.vaccine) {
              if (val.vaccine.vQ4 === '1' || (val.vaccine.vQ4 === '2' && !val.vaccine.vQ5)) {
                vaccineDate1 = val.vaccine.vQ2a;
              } else if (val.vaccine.vQ4 === '2') {
                if (val.vaccine.vQ5) {
                  vaccineDate1 = val.vaccine.vQ5;
                  vaccineDate2 = val.vaccine.vQ2a;
                } else {
                  vaccineDate2 = val.vaccine.vQ2a;
                }
              }else if (val.vaccine.vQ4 === '3') {
                vaccineDate1 = val.vaccine.vQ5;
                vaccineDate3 = val.vaccine.vQ2a;
                vaccineDate2 = val.vaccine.vQ9;
              }
            } else {
              // if no Line user data
              val = JSON.parse(JSON.stringify(this.defaultItem));

              // if there's temp data
              val.vaccine = found.vaccine || val.vaccine;
              val.history = found.history || val.history;
              val.symptom = found.symptom || val.symptom;
            }

            found.vaccine = val.vaccine
            found.vaccineDate1 = vaccineDate1;
            found.vaccineDate2 = vaccineDate2;
            found.vaccineDate3 = vaccineDate3;
            found.total_vaccine = val.vaccine.vQ4 ? parseInt(val.vaccine.vQ4) : 0;
            found.vaccine_type = val.vaccine.vQ3 || '-';
            found.vaccine_type2 = val.vaccine.vQ7 || '-';
            found.vaccine.vQ10 = (found.total_vaccine==3 && val.vaccine.vQ10)? val.vaccine.vQ10:'';
            found.vaccine_type3 = found.vaccine.vQ10 || '-';
            found.vaccine_date1 = vaccineDate1 || '-';
            found.vaccine_date2 = vaccineDate2 || '-';
            found.vaccine_date3 = vaccineDate3 || '-';
            found.history = val.history || {}
            found.symptom = val.symptom || {}
          })

          resolve();
        })
      });
    },
    refresh() {
      this.displayList = []
      this.recordList.forEach(e => {
        var locationPass = false;
        if (this.selectedLocation === this.locations[0]) {
          locationPass = true;
        } else {
          locationPass = e.bloodTests.filter(b => b.location === this.selectedLocation).length > 0;
        }

        if (locationPass) {
          this.displayList.push(e);
        }
      });
    },
    bloodTestOfRound(item, round, justChecking = false) {
      var firstTestRound = 0;
      var lastest = null;
      var found = null;

      if (round > 6) {
        // round 7 - 8
        // if has 2 jabs or jab 3 is before round 3
        if (!item.vaccineDate3) {
          return this.roundStatusNotReachable;
        }
      }

      item.bloodTests.forEach(b => {
        if (firstTestRound < b.round) {
          firstTestRound = b.round;
        }

        if (b.round === round) {
          found = b;
        }

        lastest = b;
      });

      if (found) {
        return JSON.parse(JSON.stringify(found));
      } else if (round <= firstTestRound) {
        return this.roundStatusSkip;
      } else if (
        (lastest && lastest.round + 1 === round) ||
        (round === 1 && item.bloodTests.length === 0)
      ) {
        if (!justChecking && round > 1) {
          const previousRound = this.bloodTestOfRound(item, round - 1, true);
          if (previousRound && !Number.isInteger(previousRound) && previousRound.status === this.statuses[0]) {
            // if previous round is still processing, cannot create a new round

            if (round <= 3) {
              // for round 1 2 3
              return this.roundStatusCannotCreate;
            } else {
              // for round 4 - 10
              if (round <= 6) {
                return this.roundStatusCreatableRepeat;
              } else {
                return this.roundStatusCreatable;
              }
            }
          }
        }
        return this.roundStatusCreatable;
      } else {
        if (this.hasVaccine3(item) == false) {
          return this.roundStatusUnknown;
        } else {
          return this.roundStatusCreatable;
        }
      }
    },
    interpretationOfBloodTest(bloodTest) {
      const result = parseInt(bloodTest.result ?? 0);
      const roundIndex = Math.min(bloodTest.round - 1, 2);

      var object = null;
      if (result === 1) {
        object = this.resultInterpretations[roundIndex].positive;
      } else if (result === -1) {
        object = this.resultInterpretations[roundIndex].negative;
      }

      if (!object) {
        return '';
      }

      var message = object.title + (object.description ? '\nหมายเหตุ: ' + object.description : '');

      if (bloodTest.round >= 4 && this.editedItem.vaccineDate3) {
        const vDate = new Date(this.editedItem.vaccineDate3);
        const bDate = new Date(bloodTest.date);

        if (vDate <= bDate) {
          message = object.title3 + (object.description3 ? '\nหมายเหตุ: ' + object.description3 : '');
        }
      }
      return message;
    },

    age(profile) {
      // birthDate
      if (profile.birthDate) {
        const ageDifMs = Date.now() - (new Date(profile.birthDate));
        const ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
      } else if (profile.age) {
        return profile.age;
      }
      return '';
    },

    onRoundChange () {
      if (
        this.editedItem &&
        this.canMakeAppointment(this.editedItem) &&
        this.editedItem.bloodTest &&
        this.editedItem.bloodTest.round >= 1 &&
        this.editedItem.bloodTest.round <= this.numberOfRound
      ) {
        let d = new Date(this.editedItem.vaccine_date2);
        d.setDate(d.getDate() + this.daysAfterVaccinated2[this.editedItem.bloodTest.round - 1]);

        this.$nextTick(() => {
          this.editedItem.bloodTest.date = d.toISOString().substr(0, 10);
          this.dateShow = true;

          this.$nextTick(() => {
            this.dateShow = false;
          });
        });
      }
    },
    editProfile(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editedItem.bloodTest = JSON.parse(JSON.stringify(this.defaultItem.bloodTest));
      this.editProfileOnly = true;
      this.dialog = true;
    },
    newPatient() {
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.editedItem.isNewPatient = true;
      this.editedItem.bloodTest.isNew = true;
      this.editedItem.bloodTest.status = this.statuses[0];
      this.editedItem.bloodTest.date = (new Date).toISOString().substr(0, 10);
      this.editedItem.bloodTest.time = (new Date).toISOString().substr(11, 8);
      this.editedItem.bloodTest.round = 1;
      this.interpretation = this.interpretationOfBloodTest(this.editedItem.bloodTest);
      this.editProfileOnly = false;
      this.dialog = true;
    },
    newItem(item, round = null) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editedItem.isNewPatient = false;
      this.editedItem.bloodTest = JSON.parse(JSON.stringify(this.defaultItem.bloodTest));
      this.editedItem.bloodTest.isNew = true;
      this.editedItem.bloodTest.status = this.statuses[0];
      
      // var round = 0;
      // if ((this.editedItem.bloodTests ?? []).length === 0) {
      //   round = 1;
      // } else {
      //   round = this.editedItem.bloodTests[this.editedItem.bloodTests.length - 1].round + 1;
      // }

      this.editedItem.bloodTest.round = round;

      var date = (new Date).toISOString().substr(0, 10);
      if (this.canMakeAppointment(item)) {
        const dateToAdd = this.daysAfterVaccinated2[round - 1];
        if (dateToAdd) {
          let d = new Date(item.vaccine_date2);
          d.setDate(d.getDate() + this.daysAfterVaccinated2[round - 1]);
          date = d.toISOString().substr(0, 10);
        } else {
          let d = new Date();
          date = d.toISOString().substr(0, 10);
        }
      }

      this.editedItem.bloodTest.date = date;
      this.editedItem.bloodTest.time = (new Date).toISOString().substr(11, 8);
      
      this.interpretation = this.interpretationOfBloodTest(this.editedItem.bloodTest);
      
      this.editProfileOnly = false;
      this.dialog = true;
    },
    editItem(item, round) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editedItem.bloodTest = this.bloodTestOfRound(item, round);
      this.editedItem.bloodTest.isNew = false;
      this.interpretation = this.interpretationOfBloodTest(this.editedItem.bloodTest);
      this.editProfileOnly = false;
      this.dialog = true;
    },
    
    latestVaccineInfo () {
      var message = '';
      if (this.editedItem.vaccine && 'vQ6' in this.editedItem.vaccine && this.editedItem.vaccine.vQ6) {
        if (this.editedItem.vaccine.vQ6 === 'N') {
          message = '<span class="success--text">ไม่เคยได้รับการตรวจวินิจฉัยว่าติดเชื้อไวรัสโควิด-19 มาก่อน</span><br/>'
        } else {
          message = `<span class="warning--text">` +
            `เคยได้รับการตรวจวินิจฉัยว่าติดเชื้อไวรัสโควิด-19 ` +
            `เมื่อวันที่ ${this.editedItem.vaccine.vQ6Day ?? '-'}/${this.editedItem.vaccine.vQ6Month}/${this.editedItem.vaccine.vQ6Year}` +
            `</span><br/>`;
        }
      }
      return message;
    },
    async deleteRound() {
      this.$confirm('Do you really want to delete this?').then(res => {
        if (res) {
          (async () => {
            await this.$firebase.database().ref(`immunity/blood/${this.editedItem.id}/blood${this.editedItem.bloodTest.round}`).remove();
            await this.loadBloodTest();
            this.$nextTick(() => {
              this.close();
            });
          })();
        }
      });
    },
    close() {
      this.dateShow = false;
      this.timeShow = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      });
    },

    exportData() {
      var headers = [
        // Profile
        'code',
        'firstname',
        'lastname',
        'SCG employee',
        'id card',
        'tel',
        'dob',
        'gender',
        'blood group',

        'เคยตรวจหาภูมิคุ้มกัน',
        'ระบุวันที่ตรวจ',
        'เคยได้รับการตรวจวินิจฉัย',
        'ระบุวันที่ตรวจ',
        'เคยฉีดวัคซีน',
        'จำนวนเข็ม',
        'วันที่ฉีดเข็มแรก',
        'ชนิดวัคซีนเข็มที่ 1 ที่ได้รับ',
        'วันที่ฉีดเข็มสอง',
        'ชนิดวัคซีนเข็มที่ 2 ที่ได้รับ',
        'วันที่ฉีดเข็มสาม',
        'ชนิดวัคซีนเข็มที่ 3 ที่ได้รับ',
        'ท่านอยู่ระหว่างได้รับยากดภูมิคุ้มกันหรือไม่',
        'ระบุชื่อยา',
        'ท่านมีโรคประจำตัวหรือไม่',
        'ระบุโรคประจำตัว',
        'เดินทางไปต่างจังหวัด',
        'ระบุจังหวัด',
        'เข้ารับการรักษาหรือเยี่ยมผู้ป่วย',
        'ได้ดูแลหรือสัมผัสใกล้ชิดกับผู้ป่วย',
        'มีประวัติสัมผัสกับผู้ป่วย',
        'ประกอบอาชีพที่สัมผัสใกล้ชิด',
        'เดินทางไปในสถานที่ที่มีคนหนาแน่น',
        'ระบุสถานที่',
        'มีอาการผิดปกติ',

        'มีอาการไข้',
        'ระบุอุณหภูมิ',
        'มีอาการไอ',
        'เจ็บคอ',
        'มีอาการปวดกล้ามเนื้อ',
        'มีน้ำมูก',
        'มีเสมหะ',
        'หายใจลำบาก',
        'ปวดศีรษะ',
        'ถ่ายเหลว',
        'สูญเสียการได้กลิ่น',
        'ตาแดง',
        'มีผื่นขึ้นตามตัว',
        'สูญเสียการรับรส',
        'อื่น ๆ',
      ];

      const roundHeaders = [
        'sample id',
        'status',
        'location',
        'date',
        'appointment_approved',
        'quantitative (RUmL)',
        'ratio',
        'result',
        'note'
      ];

      for (var i = 1; i <= this.numberOfRound; i++) {
        roundHeaders.forEach(r => {
          headers.push(`(${i}) ${r}`);
        });
      }

      const YesNo = (value) => {
        switch (value) {
          case 'Y': return 'ใช่';
          case 'N': return 'ไม่ใช่';
          default: return '';
        }
      }
      var exportList = [];
      this.recordList.forEach(e => {
        if(e.profile){
        var data = [
          e.profile.rCode ?? '',
          e.profile.fName ?? '-',
          e.profile.lName ?? '-',
          e.is_scg ?? '-',
          e.profile.idCard ?? '-',
          e.profile.tel ?? '-',
          e.profile.birthDate ?? '-',
          e.profile.gender ?? '-',
          e.profile.bloodType ?? '-',

          e.vaccine && e.vaccine.vQ1 ? YesNo(e.vaccine.vQ1) : '',
          e.vaccine && e.vaccine.vQ1 && e.vaccine.vQ1 === 'Y' && e.vaccine.vQ1a ? e.vaccine.vQ1a : '',
          e.vaccine && e.vaccine.vQ6 ? YesNo(e.vaccine.vQ6) : '',
          e.vaccine && e.vaccine.vQ6 && e.vaccine.vQ6 === 'Y' && e.vaccine.vQ6Month && e.vaccine.vQ6Year ?
            `${e.vaccine.vQ6Day ?? '-'}/${e.vaccine.vQ6Month}/${e.vaccine.vQ6Year}` : '',
          e.vaccine && e.vaccine.vQ2 ? YesNo(e.vaccine.vQ2) : '',
          e.vaccine && e.vaccine.vQ2 && e.vaccine.vQ2 === 'Y' && e.vaccine.vQ4 ? e.vaccine.vQ4 : '',
          e.vaccine && e.vaccine.vQ2 && e.vaccine.vQ2 === 'Y' ? e.vaccineDate1 : '',
          e.vaccine && e.vaccine.vQ2 && e.vaccine.vQ2 === 'Y' && e.vaccine.vQ3 ? e.vaccine.vQ3 : '',
          e.vaccine && e.vaccine.vQ2 && e.vaccine.vQ2 === 'Y' ? e.vaccineDate2 : '',
          e.vaccine && e.vaccine.vQ2 && e.vaccine.vQ2 === 'Y' && e.vaccine.vQ7 ? e.vaccine.vQ7 : '',
          e.vaccine && e.vaccine.vQ2 && e.vaccine.vQ2 === 'Y' ? e.vaccineDate3 : '',
          e.vaccine && e.vaccine.vQ2 && e.vaccine.vQ2 === 'Y' &&  e.vaccine.vQ4 &&  e.vaccine.vQ4 == 3 && e.vaccine.vQ10 ? e.vaccine.vQ10 : '',
          e.vaccine && e.vaccine.vQ12 ? YesNo(e.vaccine.vQ12) : '',
          e.vaccine && e.vaccine.vQ12 && e.vaccine.vQ12 === 'Y' && e.vaccine.vQ13 ? e.vaccine.vQ13 : '',
          e.vaccine && e.vaccine.vQ14 ? YesNo(e.vaccine.vQ14) : '',
          e.vaccine && e.vaccine.vQ14 && e.vaccine.vQ14 === 'Y' && e.vaccine.vQ15 ? e.vaccine.vQ15 : '',
          e.history && e.history.hQ1 ? YesNo(e.history.hQ1) : '',
          e.history && e.history.hQ1 && e.history.hQ1 === 'Y' && e.history.hQ1a ? e.history.hQ1a : '',
          e.history && e.history.hQ2 ? YesNo(e.history.hQ2) : '',
          e.history && e.history.hQ3 ? YesNo(e.history.hQ3) : '',
          e.history && e.history.hQ4 ? YesNo(e.history.hQ4) : '',
          e.history && e.history.hQ5 ? YesNo(e.history.hQ5) : '',
          e.history && e.history.hQ6 ? YesNo(e.history.hQ6) : '',
          e.history && e.history.hQ6 && e.history.hQ6 === 'Y' && e.history.hQ6a ? e.history.hQ6a : '',
          e.history && e.history.hQ7 ? YesNo(e.history.hQ7) : '',

          e.symptom && e.symptom.sQ1 ? YesNo(e.symptom.sQ1) : '',
          e.symptom && e.symptom.sQ1 && e.symptom.sQ1 === 'Y' && e.symptom.sQ1a ? e.symptom.sQ1a : '',
          e.symptom && e.symptom.sQ2 ? YesNo(e.symptom.sQ2) : '',
          e.symptom && e.symptom.sQ3 ? YesNo(e.symptom.sQ3) : '',
          e.symptom && e.symptom.sQ4 ? YesNo(e.symptom.sQ4) : '',
          e.symptom && e.symptom.sQ5 ? YesNo(e.symptom.sQ5) : '',
          e.symptom && e.symptom.sQ6 ? YesNo(e.symptom.sQ6) : '',
          e.symptom && e.symptom.sQ7 ? YesNo(e.symptom.sQ7) : '',
          e.symptom && e.symptom.sQ8 ? YesNo(e.symptom.sQ8) : '',
          e.symptom && e.symptom.sQ9 ? YesNo(e.symptom.sQ9) : '',
          e.symptom && e.symptom.sQ10 ? YesNo(e.symptom.sQ10) : '',
          e.symptom && e.symptom.sQ11 ? YesNo(e.symptom.sQ11) : '',
          e.symptom && e.symptom.sQ12 ? YesNo(e.symptom.sQ12) : '',
          e.symptom && e.symptom.sQ13 ? YesNo(e.symptom.sQ13) : '',
          e.symptom && e.symptom.sQ14 && e.symptom.sQ14 === 'Y' && e.symptom.sQ14a ? e.symptom.sQ14a : '',
        ];

        for (var i = 1; i <= this.numberOfRound; i++) {
          const bloodTest = this.bloodTestOfRound(e, i);
          if (bloodTest && !Number.isInteger(bloodTest)) {
            const result = bloodTest.result ?? '';
            data = data.concat([
              bloodTest.si ?? '',
              bloodTest.status ?? '',
              bloodTest.location ?? '',
              bloodTest.date ?? '',
              bloodTest.appointment_approved ? YesNo(bloodTest.appointment_approved): '-',
              bloodTest.RUmL ?? '',
              bloodTest.ratio ?? '',
              result === -1 ? 'Negative' : (result === 1 ? 'Positive' : ''),
              bloodTest.detail ?? ''
            ]);
          } else if (bloodTest === -1) {
            data = data.concat(new Array(roundHeaders.length).fill('ข้าม'));
          } else {
            data = data.concat(new Array(roundHeaders.length).fill(''));
          }
        }
        exportList.push(data);
        }
      });

      

      if (exportList.length === 0) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'no data to export, please change your date range and try again';
      } else {
        let data = headers.join(',') + '\n';

        exportList.sort((a, b) => {
          return (parseInt(a[0]) || 0) - (parseInt(b[0]) || 0);
        });
        exportList.forEach(e => {
          data += e.map(ee => {
            return '"' + `${ee}`.replace('"', '\\"') + '"';
          }).join(',') + '\n';
        });

        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
        element.setAttribute('download', 'download.csv');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

        this.snack = true
        this.snackColor = 'success'
        this.snackText = `${exportList.length} records exported successful`;
      }
    },

    async save() {
      if (this.editedItem.isNewPatient) {
        this.saveProfile({}, async () => {
          // this.editedItem.lineId = this.editedItem.profile.idCard;
          await this.saveBloodTest(null, null);
        });
      } else {
        if (this.editedItem.id === this.editedItem.profile.idCard) {
          this.saveProfile({}, () => {
            this.tryUpdateUserProfile(this.editedItem.profile);
          });
        } else {
          let previousRef = this.$firebase.database().ref('immunity/blood/' + this.editedItem.id);
          previousRef.once('value').then((snapshot) => {
            var blood = snapshot.val();
            blood.profile = this.editedItem.profile;

            this.saveProfile(blood, async () => {
              await previousRef.remove();
              this.tryUpdateUserProfile(blood.profile);
            });
          });
        }
      }
    },
    canSaveProfile() {
      return this.editedItem !== null &&
        // this.editedItem.user !== null && // for user without Line profile
        this.editedItem.profile !== null &&
        this.editedItem.profile.idCard !== null && this.editedItem.profile.idCard !== '' &&
        this.editedItem.profile.fName !== null && this.editedItem.profile.fName !== '' &&
        this.editedItem.profile.lName !== null && this.editedItem.profile.lName !== '' &&
        this.editedItem.profile.tel !== null && this.editedItem.profile.tel !== '' &&
        (this.editedItem.vaccine.vQ12 != 'Y' || this.editedItem.vaccine.vQ13) &&
        (this.editedItem.vaccine.vQ14 != 'Y' || this.editedItem.vaccine.vQ15) &&
        (this.editProfileOnly || (
          this.editedItem.profile.round !== null && this.editedItem.profile.round !== '' &&
          parseInt(this.editedItem.bloodTest.round) >= 1 && parseInt(this.editedItem.bloodTest.round) <= this.numberOfRound
        ));
    },
    async saveProfile(previousData, callback) {
      this.loading = true;
      try {
        let profile = Object.assign({}, this.editedItem.profile);
        profile.age = this.age(profile);
        let data = {
          ...previousData,
          profile,
          uid: this.editedItem.lineId ?? '',
        };

        if (!this.editedItem.user) {
          data = {
            ...data,
            vaccine: this.editedItem.vaccine,
            history: this.editedItem.history,
            symptom: this.editedItem.symptom,
          };
        }

        this.$firebase.database().ref(`immunity/blood/${profile.idCard}`)
          .update(data)
          .then(() => {
            callback();
          })
          .catch((e) => {
            this.loading = false;
            this.close();

            this.snack = true
            this.snackColor = 'error'
            this.snackText = 'Error ' + e.message
          })
      } catch (e) {
        this.loading = false;
        this.close();

        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Error ' + e.message

        console.error(e);  
      }
    },
    async tryUpdateUserProfile(profile) {
      if (this.editedItem.profile.status === 'approve') {
        await this.saveUserProfile(profile, this.editedItem.lineId);
        await this.saveBloodTest(null, null);
      } else {
        await this.saveBloodTest(null, null);
      }
    },
    async saveUserProfile (profile, lineId) {
      return new Promise((resolve, reject) => {
        let data = {
          profile: profile,
        }

        let vaccine = this.editedItem.vaccine;
        if (vaccine) {
          if (vaccine.vQ2 === 'N') {
            vaccine.vQ3 = '';
            vaccine.vQ7 = '';
            vaccine.vQ10 = '';
            vaccine.vQ4 = '';
            vaccine.vQ2a = '';
            vaccine.vQ5 = '';
          } else {
            if (vaccine.vQ4 === '1') {
              vaccine.vQ2a = this.editedItem.vaccineDate1;
              vaccine.vQ5 = '';
            } else 
            if (vaccine.vQ4 === '2') {
              vaccine.vQ5 = this.editedItem.vaccineDate1;
              vaccine.vQ2a = this.editedItem.vaccineDate2;
            }else 
            if (vaccine.vQ4 === '3') {
              vaccine.vQ5 = this.editedItem.vaccineDate1;
              vaccine.vQ9 = this.editedItem.vaccineDate2;
              vaccine.vQ2a = this.editedItem.vaccineDate3;
            }
          }
          if (!vaccine.vQ12 || vaccine.vQ12 != 'Y') {
            vaccine.vQ13 = '';
          }
          if (!vaccine.vQ14 || vaccine.vQ14 != 'Y') {
            vaccine.vQ15 = '';
          }

          data.vaccine = vaccine;
        }

        this.$firebase.database().ref('immunity/user/' + lineId)
          .update(data)
          .then(() => {
            resolve();
          })
          .catch((e) => {
            this.loading = false;
            this.close();

            this.snack = true
            this.snackColor = 'error'
            this.snackText = 'Error ' + e.message
            reject();
          })
      });
    },
    async saveBloodTest(_, nextData = null) {
      return new Promise((resolve, reject) => {
        const saveSuccess = () => {
          this.loading = false;
          this.close();
          this.$nextTick(() => {
            this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
            this.loadBloodTest()
          });

          this.snack = true
          this.snackColor = 'success'
          this.snackText = 'Save success'

          resolve();
        }

        if (this.editProfileOnly) {
          saveSuccess();
          return;
        }

        this.loading = true;
        try {
          const idCard = this.editedItem.profile.idCard
          let data = nextData ? nextData : JSON.parse(JSON.stringify(this.editedItem.bloodTest));
          delete data.isNew;
          delete data.previousRound;

          const previousRound = parseInt(this.editedItem.bloodTest.previousRound);
          data.round = parseInt(data.round);
          const shouldDeleteRound = isNaN(previousRound) || previousRound === data.round ? null : previousRound;

          if (nextData === null && shouldDeleteRound !== null) {
            // remove from RTDB
            this.$firebase.database().ref(`immunity/blood/${idCard}/blood${shouldDeleteRound}`).remove();

            // remove from temp object
            const index = this.editedItem.bloodTests.findIndex(e => e.round === shouldDeleteRound);
            if (index > -1) {
              this.editedItem.bloodTests.splice(index, 1);
            }
          }

          this.$firebase.database().ref(`immunity/blood/${idCard}/blood${data.round}`)
            .update(data)
            .then(() => {
              (async () => {
                // Store updated data into recordList incase createTheRestOfRoundBloodTest() will use it
                const tmp = this.recordList.filter(b => b.id === idCard);
                if (tmp.length > 0) {
                  var index = tmp[0].bloodTests.findIndex(e => e.round === data.round);
                  if (index > -1) {
                    tmp[0].bloodTests[index] = data;
                  } else {
                    tmp[0].bloodTests.push(data);
                  }

                  index = this.editedItem.bloodTests.findIndex(e => e.round === data.round);
                  if (index > -1) {
                    this.editedItem.bloodTests[index].date = data.date;
                  } else {
                    this.editedItem.bloodTests.push(data);
                  }
                }

                const round = parseInt(data.round);
                if (nextData === null) {
                  if (round >= 2 && this.canMakeAppointment(this.editedItem)) {
                    await this.createTheRestOfRoundBloodTest(this.editedItem, data, round + 1);
                    saveSuccess();
                    resolve();
                    return;
                  } else {
                    saveSuccess();
                    resolve();
                  }
                } else {
                  // nextData is not null, means we're currently updating the rest of rounds
                  resolve();
                }
              })();
            })
            .catch((e) => {
              this.loading = false;
              this.close();

              this.snack = true
              this.snackColor = 'error'
              this.snackText = 'Error ' + e.message
              reject(e);
            })
        } catch (e) {
          this.loading = false;
          this.close();

          this.snack = true
          this.snackColor = 'error'
          this.snackText = 'Error ' + e.message

          console.error(e);  
          reject(e);
        }
      });
    },
    log () {
      if (Object.keys(arguments).length > 0) {
        console.log.apply(null, arguments);
      }
    },
    weekDiff (a, b) {
      var at = a.getTime();
      var bt = b.getTime();
      return parseInt((bt - at) / 604800000);
    },
    firstOrNull (items) {
      if (items.length > 0) {
        return items[0];
      }
      return null;
    },
    hasVaccine2 (item) {
      return item.vaccine.vQ4 && parseInt(item.vaccine.vQ4) >= 2 && item.vaccineDate2;
    },
    hasVaccine3 (item) {
      return item.vaccine.vQ4 && parseInt(item.vaccine.vQ4) >= 3 && item.vaccineDate3;
    },
    canMakeAppointment (item) {
      return this.hasVaccine2(item) || this.hasVaccine3(item);
    },
    firstRoundAfterVaccine3 (item) {
      var firstRound = null;

      if (this.hasVaccine3(item)) {
        const vaccine3date = new Date(item.vaccineDate3);

        // daysAfterVaccinated2: [0, 0, 28, 84, 168, 336],
        //                               4   8   12   24
        //                               1   2    3    6
        //                               4  12   24   48
        //                               1   3    6   12

        for (var j = 3; j <= this.numberOfRound; j++) {
          var lastDate = new Date(item.vaccineDate3);
          var nextRoundDate = 0;

          const blood = this.firstOrNull(item.bloodTests.filter(b => parseInt(b.round) === j));
          if (blood && blood.status === this.statuses[1]) {
            lastDate = new Date(blood.date);
          } else {
            nextRoundDate = this.daysAfterVaccinated2[j - 1];
            if (nextRoundDate) {
              lastDate.setDate(lastDate.getDate() + nextRoundDate + this.additionalDays);
            } else {
              continue;
            }
          }

          if (vaccine3date <= lastDate) {
            // this.log(`${j} ${vaccine3date.toISOString().substr(0, 10)} <= ${lastDate.toISOString().substr(0, 10)} (+ ${nextRoundDate} days, ${vaccine3date <= lastDate})`);
            firstRound = j;
            break;
          }
        }
      }

      return firstRound;
    },
    lastRoundAfterVaccine3 (item) {
      const firstRoundAfterVaccine3 = this.firstRoundAfterVaccine3(item);
      return this.hasVaccine3(item) && firstRoundAfterVaccine3 ? firstRoundAfterVaccine3 + 3 : null;
    },
    async createTheRestOfRoundBloodTest(item, currentData, nextRound) {
      return new Promise((resolve) => {
        (async () => {
          // update all the blood tests's date
          for (var i = nextRound; i <= this.numberOfRound; i++) {
            const bloodIndex = item.bloodTests.findIndex(b => parseInt(b.round) === i);
            var bloodTest = null;
            if (bloodIndex === -1) {
              // blood test not found
              bloodTest = JSON.parse(JSON.stringify(this.defaultItem.bloodTest));
              bloodTest.round = i;
              bloodTest.isNew = true;
              bloodTest.status = this.statuses[0];
            } else if (item.bloodTests[bloodIndex].status !== this.statuses[0]) {
              // blood test's status is not "waiting", status will be check before update
              bloodTest = JSON.parse(JSON.stringify(item.bloodTests[bloodIndex]));
            } else {
              // blood test's status is "waiting"
              bloodTest = JSON.parse(JSON.stringify(item.bloodTests[bloodIndex]));
            }

            var d = null;
            if (!this.hasVaccine3(item)) {
              // if have only 2 vaccines
              if (i <= 6) {
                // if round 1 - 6
                const previousBloodTests = item.bloodTests.filter(b => parseInt(b.round) === i - 1);
                if (previousBloodTests.length > 0) {
                  d = new Date(previousBloodTests[0].date);
                  d.setDate(d.getDate() + this.daysAfterPrevious[i - 1]);

                  this.log(`(2jabs) Round ${i} date from previous round, ${previousBloodTests[0].date} + ${this.daysAfterPrevious[i - 1]} days = ${d.toISOString().substr(0, 10)} (${this.weekDiff(new Date(previousBloodTests[0].date), d)} weeks)`);
                } else {
                  d = new Date(item.vaccineDate2);
                  d.setDate(d.getDate() + this.daysAfterVaccinated2[i - 1]);

                  this.log(`(2jabs) Round ${i} date from round 2, ${item.vaccineDate2} + ${this.daysAfterVaccinated2[i - 1]} days = ${d.toISOString().substr(0, 10)} (${this.weekDiff(new Date(item.vaccineDate2), d)} weeks)`);
                }
              } else {
                // if round 7+
                const blood = this.firstOrNull(item.bloodTests.filter(b => parseInt(b.round) === i));
                if (blood && blood.status === this.statuses[0]) {
                  await this.$firebase.database().ref(`immunity/blood/${item.id}/blood${i}`).remove();
                }
              }
            } else {
              // if have 3 vaccines

              // check if current round comes before calculated first round after vaccine 3
              const firstRoundAfterVaccine3 = this.firstRoundAfterVaccine3(item);
              if (!firstRoundAfterVaccine3) {
                this.log(`Could not calculate first round after vaccine 3`);
                continue;
              } else if (i < firstRoundAfterVaccine3) {
                this.log(`Round ${i} is before first round after vaccine 3 (${firstRoundAfterVaccine3})`);

                const blood = this.firstOrNull(item.bloodTests.filter(b => parseInt(b.round) === i));
                if (blood && blood.status === this.statuses[0]) {
                  await this.$firebase.database().ref(`immunity/blood/${item.id}/blood${i}`).remove();
                }

                continue;
              }

              // check if current round comes after calculated last round after vaccine 3
              const lastRoundAfterVaccine3 = this.lastRoundAfterVaccine3(item);
              if (lastRoundAfterVaccine3 && i > lastRoundAfterVaccine3) {
                const blood = this.firstOrNull(item.bloodTests.filter(b => parseInt(b.round) === i));
                if (blood) {
                  this.log(`Round ${i} cannot create/update, but it will not be deleted`);
                  // await this.$firebase.database().ref(`immunity/blood/${item.id}/blood${i}`).remove();
                }
                continue;
              }

              // current round comes between calculated first & last round after vaccine 3

              if (bloodTest.status !== this.statuses[0]) {
                continue;
              }

              // daysAfterVaccinated2: [0, 0, 28, 84, 168, 336],
              //                               4   8   12   24
              //                               1   2    3    6
              //                               4  12   24   48
              //                               1   3    6   12

              d = new Date(item.vaccineDate3);
              const dateToAdd = this.daysAfterVaccinated2[i - firstRoundAfterVaccine3 + 2];
              d.setDate(d.getDate() + dateToAdd);
              this.log(`(3jabs) Round ${i} first round ${firstRoundAfterVaccine3}, ${item.vaccineDate3} + ${dateToAdd} days = ${d.toISOString().substr(0, 10)} (${this.weekDiff(new Date(item.vaccineDate3), d)} weeks)`);
            }

            if (bloodTest.status === this.statuses[0] && d) {
              // Actual save
              bloodTest.date = d.toISOString().substr(0, 10),
              bloodTest.time = currentData.time;
              await this.saveBloodTest(null, bloodTest);
            }
          }
          resolve();
        })();
      });
    },
    async checkAppointment() {
      this.dialogAutoAppointment = false;
      this.showLoadingSnack();

      var addCount = 0;
      var deleteCount = 0;

      for (var i = 0; i < this.selected.length; i++) {
        const [isAdd, isDelete] = await this.checkAppointmentItem(this.selected[i]);
        addCount += (isAdd ? 1 : 0);
        deleteCount += (isDelete ? 1 : 0);
      }

      this.hideLoadingSnack();

      setTimeout(() => {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = `Success. Total added ${addCount}, total deleted ${deleteCount}`
        this.loadBloodTest()
      }, 1000);
    },
    async checkAppointmentSingleItem(item) {
      this.showLoadingSnack();

      await this.checkAppointmentItem(item);

      this.hideLoadingSnack();

      setTimeout(() => {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = `Success`
        this.loadBloodTest()
      }, 1000);
    },
    async checkAppointmentItem(item) {
      return new Promise((resolve) => {
        (async () => {
          var isAdd = false;
          var isDelete = false;

          const shouldDeleteRounds = (item.bloodTests || []).filter(f => f.round >= 3 && f.status !== this.statuses[1]);
          if (!this.canMakeAppointment(item)) {
            if (shouldDeleteRounds.length > 0) {
              // has round 3 4 5 6 appointment incorrectly
              for (var i = 0; i < shouldDeleteRounds.length; i++) {
                await this.$firebase.database().ref(`immunity/blood/${item.id}/blood${shouldDeleteRounds[i].round}`).remove();
              }
              isDelete = true;
            }
          } else if (item.bloodTests && item.bloodTests.length >= 1) {
            var latestRound = null;
            item.bloodTests.forEach(e => {
              if (latestRound === null || latestRound.round < e.round) {
                latestRound = e;
              }
            });

            if (latestRound && latestRound.round < 6) {
              isAdd = true;

              const nextRound = latestRound.round + 1;
              for (var k = nextRound; k <= this.numberOfRound; k++) {
                if (item.bloodTests.filter(b => parseInt(b.round) === k).length > 0) {
                  // already exists
                  continue;
                }

                const nextRound = this.daysAfterVaccinated2[k - 1];
                if (!nextRound) {
                  continue;
                }

                let d = new Date(item.vaccineDate2);
                d.setDate(d.getDate() + nextRound);

                let bloodTest = JSON.parse(JSON.stringify(this.defaultItem.bloodTest));
                bloodTest.round = k;
                bloodTest.status = this.statuses[0];
                bloodTest.date = d.toISOString().substr(0, 10),
                bloodTest.time = latestRound.time;

                try {
                  this.$firebase.database().ref(`immunity/blood/${item.id}/blood${bloodTest.round}`)
                    .update(bloodTest)
                    .then(() => {})
                    .catch((e) => {
                      console.error(e);
                    })
                } catch (e) {
                  console.error(e);
                }
              }
            }
          }

          resolve([isAdd, isDelete]);
        })();
      });
    },
    showInfoSnack (message) {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = message
    },
    showLoadingSnack () {
      this.snackLoading = true;
    },
    hideLoadingSnack () {
      this.snackLoading = false;
    },
    employeeType (profile) {
      if (!profile || 'pQ1' in profile === false) {
        return '-';
      }

      return this.employeeTypes[profile.pQ1] ?? '[invalid]';
    }
  },
  filters: {
    profileName: function(profile) {
      if (!profile) {
        return '-';
      }

      var name = profile.fName;
      if (name && profile.lName) {
        name += ` ${profile.lName}`;
      } else if (profile.lName) {
        name = profile.lName;
      }
      
      return name ?? '-';
    },
    blankOrDash: function (text) {
      if (!text || `${text}` === '') {
        return '-';
      }
      return text;
    },
    dateTime: function (bloodTest) {
      if (!bloodTest) {
        return '-';
      }
      return moment(bloodTest.date + ' ' + bloodTest.time).format('DD/MM/YYY h:mm');
    },
    isoToShortDate: function (date) {
      if (!date || date.length !== 10) {
        return date;
      }
      const array = date.split('-');
      return `${array[2]}/${array[1]}/${array[0]}`
    },
    shortDate: function (date) {
      if (!date || date.length !== 10) {
        return '-';
      }

      return moment(date).format('DD/MM/YYYY');
    },
    employeeType: function (profile) {
      if (!profile || 'pQ1' in profile === false) {
        return '-';
      }

      switch (profile.pQ1) {
        case 'CBM': return 'SCG CBM';
        case 'CHEM': return 'SCG Chemicals';
        case 'PACK': return 'SCG Packaging';
        case 'CAFI': return 'SCG CA&FI';
        case 'OTHER': return 'พนักงานในเครือ';
        case 'NONSCG': return 'ไม่ใช่';
      }
    }
  }
};
</script>

<style>
.v-text-field.mt-0 input {
  margin-top: initial !important;
}
</style>